import { motion } from "framer-motion";
import { useGame } from "../../context/GameContext.jsx";
import { useLanguage } from "../../hooks/useLanguage.js";
import { ROLE_DATA } from "../../data/roles.js";
import { ClickablePlayer } from "./ClickablePlayer.jsx";

export function DeadPlayersModal({ players, onClose }) {
  const { state } = useGame();
  const { t, lang } = useLanguage();
  const dead = players.filter(p => !p.alive);

  return (
    <motion.div
      initial={{ opacity:0 }} animate={{ opacity:1 }} exit={{ opacity:0 }}
      className="fixed inset-0 z-[9998] flex items-end justify-center"
      style={{ background:"rgba(0,0,0,0.8)" }}
      onClick={onClose}>
      <motion.div
        initial={{ y:"100%" }} animate={{ y:0 }} exit={{ y:"100%" }}
        transition={{ type:"spring", stiffness:300, damping:30 }}
        onClick={e => e.stopPropagation()}
        className="w-full max-w-md bg-stone-950 border-t border-amber-900/30
          rounded-t-3xl px-4 pt-4 pb-10 max-h-[70vh] overflow-y-auto">
        <div className="w-10 h-1 bg-amber-900/40 rounded-full mx-auto mb-4" />
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-amber-200 font-bold">
            💀 {t("Joueurs éliminés","Eliminated players")} ({dead.length})
          </h2>
          <button onClick={onClose}
            className="text-amber-700 w-8 h-8 flex items-center justify-center rounded-xl bg-amber-950/50 active:scale-95">✕</button>
        </div>
        {dead.length === 0 ? (
          <p className="text-amber-800/50 text-sm text-center italic py-4">
            {t("Personne n'est mort pour l'instant.","Nobody has died yet.")}
          </p>
        ) : (
          <div className="flex flex-col gap-2">
            {dead.map(p => {
              const role = ROLE_DATA[p.baseRoleId];
              return (
                <div key={p.id} className="flex items-center gap-3 rounded-2xl p-3
                  bg-stone-900/50 border border-stone-800/30">
                  <div className={`w-9 h-9 rounded-xl flex items-center justify-center text-lg shrink-0
                    bg-gradient-to-br ${role?.gradient} opacity-60`}>
                    {role?.emoji}
                  </div>
                  <div className="flex-1">
                    <ClickablePlayer player={p} className="text-sm text-stone-300" />
                    <p className="text-stone-600 text-xs">
                      {lang === "fr" ? role?.frenchName : role?.englishName}
                    </p>
                  </div>
                  <span className="text-stone-600 text-xs">
                    {p.deathNight ? `N${p.deathNight}` : ""}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </motion.div>
    </motion.div>
  );
}
